// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"099ab050","742":"f2a74f08"}[chunkId] + ".chunk.css";
};